
import { Facet } from '../models/Facet';
import { IOperationActionCreator } from '../store/actions/implementOperation';
import { implementOperationWithProgress, ProgressKeyFacet } from './progress';
import { KeyFacet, stringPart } from '../models/KeyFacet';

export const renameItemOperation = new Facet<{
  names: {
    [oldName: string]: {
      newName: string;
      newExtension?: string;
    };
  };
}>('renameItem');

const renameItemProgressItemKeyFacet = new KeyFacet<{
  itemKey: string;
  oldName: string;
}>('renameItemProgressItem', {
  itemKey: stringPart(),
  oldName: stringPart()
});

export const renameProgressKeyFacet = new ProgressKeyFacet('renameItems', (itemKey: string, options: typeof renameItemOperation.type) => {
  const [oldName] = Object.keys(options.names);

  return renameItemProgressItemKeyFacet.serialize({
    itemKey: itemKey,
    oldName: oldName
  });
});

export const renameItem: IOperationActionCreator<typeof renameItemOperation.type> = implementOperationWithProgress({
  operationTypeFacet: renameItemOperation,
  progressKeyFacet: renameProgressKeyFacet
});